import { render, staticRenderFns } from "./EipRadio.vue?vue&type=template&id=be647e16&scoped=true&"
import script from "./EipRadio.vue?vue&type=script&lang=js&"
export * from "./EipRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be647e16",
  null
  
)

export default component.exports